function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "CheckboxInactive_svg__52_a",
  width: "143.8%",
  height: "143.8%",
  x: "-21.9%",
  y: "-15.6%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0"
})), React.createElement("rect", {
  id: "CheckboxInactive_svg__53_b",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  rx: 4
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 1)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#CheckboxInactive_svg__52_a)",
  xlinkHref: "#CheckboxInactive_svg__53_b"
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 0.5,
  y: 0.5,
  fill: "#FFF",
  stroke: "#C0D0DF",
  strokeLinejoin: "square",
  rx: 4
}));

var SvgCheckboxInactive = function SvgCheckboxInactive(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default SvgCheckboxInactive;